import { axiosInstance } from '../axiosInstance';

export const removeFavoritesApi = async (
  token: string | null,
  data: { type: 'product' | 'part' | 'accessory'; id: string },
): Promise<any> => {
  const headers: { Authorization?: string } = {};
  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await axiosInstance.post(`/view/favorites/remove/`, data, {
    headers,
  });

  return response.data;
};
